import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from '../layout/Column';
import { SelectField } from '../form/SelectField';
import { FieldsGroup } from '../form/FieldsGroup';
import Checkbox from '../form/Checkbox';
import { Row } from '../layout/Row';
import { WebPlayerHeaderProps } from '../../types/webPlayer';

const WebPlayerHeader = (props: WebPlayerHeaderProps) => {
  const { t } = useTranslation();
  const {
    ground,
    groundOptions,
    groundSet,
    isSessionDataReady,
    jerseyOrNumber,
    setGround,
    setJerseyOrNumber,
    setTrailsEnabled,
    trailsEnabled,
  } = props;

  const handleGroundSelectChange = useCallback((e) => {
    const selectedName = e.target.value;
    const selectedGround = groundSet.filter((g) => g.name === selectedName)[0];

    setGround(selectedGround);
  }, [groundSet, setGround]);

  const handleJerseySelectChange = useCallback(() => {
    setJerseyOrNumber((prev) => !prev);
  }, [setJerseyOrNumber]);

  const handleTrailsSelectChange = useCallback(
    () => setTrailsEnabled((prev) => !prev),
    [setTrailsEnabled],
  );

  return (
    <Row style={{ paddingLeft: '10px', paddingRight: '30px' }}>
      <Column xs={8}>
        <Row>

          <Column xs={4}>
            <SelectField
              required
              fullWidth
              label={t('grounds.ground', 'ground')}
              value={ground?.name || ''}
              options={groundOptions}
              onChange={handleGroundSelectChange}
              disabled={!isSessionDataReady}
            />
          </Column>
          <Column xs={6}>
            <FieldsGroup
              label={`${
                t('athlete.widgets.label.shortName', 'short name')
              }/${
                t('athlete.widgets.label.jersey', 'jersey')
              }`}
              onChange={handleJerseySelectChange}
              options={[
                {
                  value: true,
                  label: t('athlete.widgets.label.shortName', 'short name'),
                },
                {
                  value: false,
                  label: t('athlete.widgets.label.jersey', 'jersey'),
                },
              ]}
              type="radio"
              value={jerseyOrNumber}
            />
          </Column>
          <Column xs={2}>
            <Checkbox
              value={trailsEnabled}
              label={t('session.labels.trails', 'trails')}
              onClick={handleTrailsSelectChange}
            />

          </Column>

        </Row>
      </Column>
    </Row>
  );
};

export default memo(WebPlayerHeader);
